// --- DEBUG import (temporary; remove with the debug logging below) ---
import Cookies from 'js-cookie';

import apiClient from '../middleware/apiClient';


// import { formatFetchNewLabelPayload } from '../helpers/order';
import { DSM_RETURNS, COTTON_DSM_RETURNS, COTTON_V1_DSM_RETURNS } from '../helpers/apis';
import { callApiWithFallback } from '../helpers/apiFallback';
import { kibanaLog, getGuid } from '../helpers/logger';
import cottonFlagManager from '../helpers/featureFlags/cotton';
// --- DEBUG imports (temporary; remove with the debug logging below) ---
import { lowerEnvConsoleLog, lowerEnvConsoleWarn } from '../helpers/lowerEnvConsoleLog';
import { isReady } from '../helpers/featureFlags';
import { getUserSegment } from '../helpers/segmentation';

// Fetch Returns
export const FETCH_RETURNS = 'FETCH_RETURNS';
export const FETCH_RETURNS_SUCCESS = 'FETCH_RETURNS_SUCCESS';
export const FETCH_RETURNS_FAILURE = 'FETCH_RETURNS_FAILURE';
export const RESET_RETURNS = 'RESET_RETURNS';

function fetchReturns(endpoint = DSM_RETURNS) {
  return {
    type: FETCH_RETURNS,
    payload: apiClient.fetch(
      endpoint,
    ),
  };
}

function fetchReturnsSuccess(returns) {
  return {
    type: FETCH_RETURNS_SUCCESS,
    payload: returns,
  };
}

function fetchReturnsFailure(error) {
  return {
    type: FETCH_RETURNS_FAILURE,
    payload: error,
  };
}

export const loadReturns = () => async (dispatch, getState) => {
  const { requested, loading, cacheValid } = getState().returns || {};
  if (cacheValid) {
    return null;
  }
  try {
    let response;
    const { isAptV1Enabled, dsmReturnsEnabled } = cottonFlagManager;

    // --- DEBUG: prove flag-evaluation/timing state at the returns decision point ---
    const debugSnapshot = {
      api: 'dsm_returns',
      guid: String(getGuid()),
      // in-flight / double-dispatch proof
      in_flight_requested: String(requested),
      in_flight_loading: String(loading),
      in_flight_cache_valid: String(cacheValid),
      overlapping_call: String(Boolean(requested) && !cacheValid),
      // flag-readiness (timing) proof
      flags_ready: String(isReady()),
      decision_before_flags_ready: String(!isReady()),
      // evaluated gating chain
      master_flag: String(cottonFlagManager.masterFlag),
      cotton_allowed: String(cottonFlagManager.cottonAllowed),
      is_base_enabled: String(cottonFlagManager.isBaseEnabled),
      is_apt_v1_enabled: String(isAptV1Enabled),
      dsm_returns_enabled: String(dsmReturnsEnabled),
      disable_ruby_apis: String(cottonFlagManager.disableRubyApis),
      // cookies / segmentation (rule-out fields)
      cotton_allowed_cookie: String(Cookies.get('cotton_allowed')),
      xf_seg_cookie: String(Cookies.get('xf_seg')),
      user_segment: String(getUserSegment()),
    };
    lowerEnvConsoleLog('[DEBUG dsm_returns gating]', debugSnapshot);
    kibanaLog('debug_dsm_returns_gating', debugSnapshot);
    // --- END DEBUG ---

    if (isAptV1Enabled) {
      // Use APT V1 API (100% Kotlin)
      kibanaLog('apt_v1_dsm_returns_api_called');
      response = await dispatch(fetchReturns(COTTON_V1_DSM_RETURNS)).payload;
    } else if (dsmReturnsEnabled) {
      // Try Cotton API, fallback to Ruby API
      response = await callApiWithFallback(
        dispatch,
        () => fetchReturns(COTTON_DSM_RETURNS), // Cotton API call
        () => fetchReturns(DSM_RETURNS), // Ruby API call
        'dsm_returns',
      );
    } else {
      // Only call Ruby API
      // --- DEBUG: direct Ruby branch => cotton flags evaluated false at request time ---
      lowerEnvConsoleWarn('[DEBUG dsm_returns] RUBY-ONLY branch taken (cotton flags false)', debugSnapshot);
      kibanaLog('debug_dsm_returns_ruby_only_branch', debugSnapshot);
      // --- END DEBUG ---
      response = await dispatch(fetchReturns(DSM_RETURNS)).payload;
    }
    return dispatch(fetchReturnsSuccess(response));
  } catch (error) {
    return dispatch(fetchReturnsFailure(error));
  }
};
